export default {
    "id": 0,
    "test_instruction": {},
    "auto": {
        "covers": [],
        "region": {},
        "register_region": {},
        "license_plate": "",
        "vin_no": "",
        "meter_mileage": 0,
        "displacement": 0,
        "displacement_unit": "L",
        "model": "",
        "gearbox_type": "",
        "gearbox_no": "",
        "gearbox_model": "",
        "first_boarding_date": "",
        "vehicle_color": "",
        "vehicle_use": "",
        "nature_of_use": "",
        "maintenance_status": "",
        "annual_inspection_expiration": "",
        "strong_insurance_expiry": "",
        "vehicle_source": "",
        "amount_of_protection_number": "",
        "amount_of_protection_zh": "",
        "identifier": "",
        "create_at": "",
        "remark": ""
    },
    "customer": {
        "region": "",
        "date_of_birth": "",
        "email": "",
        "mobile": "",
        "username": "",
        "name": "",
        "sex": "",
        "thumb": "",
        "age": "",
        "nickname": "",
        "userid": "",
        "idcard_no": "",
        "identifier": "",
        "create_at": ""
    },
    "group_objects": [{
        "detected": false,
        "test_result": "",
        "group": {
            "covers": "",
            "group_items": [{
                "items": [{
                    "name": "",
                    "mode": "",
                    "identifier": "",
                    "create_at": "",
                    "placeholder": "",
                    "text_mode": "",
                    "finish_mode": ""
                }, ],
                "name": "",
                "choice_mode": "",
                "identifier": "",
                "create_at": ""
            }, ],
            "test_instruction": {},
            "name": "",
            "identifier": "",
            "create_at": "",
            "cover_mode": ""
        },
        "identifier": "",
        "create_at": "",
        "detect_detectitemobject_group_object": [{
            "images": [],
            "videos": [],
            "detect_item": {
                "name": "",
                "mode": "",
                "identifier": "",
                "create_at": "",
                "placeholder": "",
                "text_mode": "",
                "finish_mode": ""
            },
            "detect_group_item": {
                "items": [{
                    "name": "",
                    "mode": "",
                    "identifier": "",
                    "create_at": "",
                    "placeholder": "",
                    "text_mode": "",
                    "finish_mode": ""
                }],
                "name": "",
                "choice_mode": "",
                "identifier": "",
                "create_at": ""
            },
            "checked": null,
            "text": "",
            "identifier": "",
            "create_at": ""
        }, ]
    }, ],
    "menu": {
        "groups": [{
            "covers": "",
            "group_items": [{
                "items": [{
                    "name": "",
                    "mode": "",
                    "identifier": "",
                    "create_at": "",
                    "placeholder": ""
                }],
                "name": "",
                "choice_mode": "",
                "identifier": "",
                "create_at": "",
                "value": "",
            }, ],
            "name": "",
            "identifier": "",
            "create_at": "",
            "mode": ""
        }, ],
        "name": "",
        "mode": "BASE",
        "identifier": "",
        "create_at": "",
        "test_instruction": {
            "name": "",
            "instruction": "",
            "mode": "",
        }
    },
    "inspector": {
        "appraisal_certificates": [{
            "image_url": "",
            "image": "",
            "url": "",
            "download_url": "",
            "name": "",
            "width": 0,
            "height": 0,
            "create_at": "",
            "update_at": "",
            "description": "",
            "path": "",
            "cdn_domain": "",
            "identifier": "",
            "region": {}
        }, ],
        "thumb_url": "",
        "region": {
            "name": "",
            "language": "",
            "region": "",
            "region_code": "",
            "country": "",
            "country_code": "",
            "province": "",
            "province_code": "",
            "city": "",
            "address": "",
            "town": "",
            "district": "",
            "full_address": "",
            "latitude": "",
            "longitude": ""
        },
        "date_of_birth": "",
        "email": "",
        "mobile": "",
        "username": "",
        "name": "",
        "sex": "",
        "thumb": "",
        "age": 0,
        "nickname": "",
        "userid": "",
        "idcard_no": "",
        "self_introduction": "",
        "level": "",
        "identifier": "",
        "create_at": "",
        "user": {}
    },
    "remark": "",
    "maintenance_recommendations": "",
    "identifier": "",
    "create_at": "",
    "update_at": "",
    "special_desc": "",
    "test_result": "",
    "detected": false,
    "detect_group_item_object_list": [{
        "images": [],
        "videos": [],
        "group_object": {
            "group": {
                "covers": "",
                "group_items": [{
                    "items": [{
                        "name": "",
                        "mode": "",
                        "identifier": "",
                        "create_at": "",
                        "placeholder": ""
                    }, ],
                    "name": "",
                    "choice_mode": "",
                    "identifier": "",
                    "create_at": ""
                }, ],
                "name": "",
                "identifier": "",
                "create_at": "",
                "mode": "",
                "test_instruction": {
                    "name": "",
                    "instruction": "",
                    "mode": "",
                }
            },
            "detected": false,
            "test_result": "",
            "identifier": "",
            "create_at": ""
        },
        "detect_item": {
            "name": "",
            "mode": "",
            "identifier": "",
            "create_at": "",
            "placeholder": ""
        },
        "detect_group_item": {
            "items": [{
                "name": "",
                "mode": "",
                "identifier": "",
                "create_at": "",
                "placeholder": ""
            }, ],
            "name": "",
            "choice_mode": "",
            "identifier": "",
            "create_at": "",
            "mode": "",
            "test_instruction": {
                "name": "",
                "instruction": "",
                "mode": "",
            }
        },
        "checked": false,
        "text": "",
        "identifier": "",
        "create_at": ""
    }, ]
}